import { useEffect, useState } from "react";
import { api, errMsg, fmtDate } from "@/lib/api";

const BADGE = { late: "bg-red-100 text-red-700", on_time: "bg-emerald-100 text-emerald-700", absent: "bg-slate-100 text-slate-600", on_leave: "bg-sky-100 text-sky-700" };
const LABEL = { late: "Late", on_time: "On time", absent: "No sign-in", on_leave: "On leave" };

export default function AttendanceAdmin() {
  const [day, setDay] = useState(new Date(Date.now() + 3 * 3600 * 1000).toISOString().slice(0, 10));
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/attendance/team", { params: { day } }).then((r) => { setD(r.data); setErr(""); }).catch((e) => setErr(errMsg(e))); }, [day]);
  return (
    <div className="ch chs phd space-y-4" data-testid="attendance-admin">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="max-w-xl text-sm text-muted-foreground">Every active staff member for the chosen day. Times come from activity in the app (Tanzania time).</p>
        <input type="date" value={day} onChange={(e) => setDay(e.target.value)} className="rounded-md border bg-background px-2 py-1.5 text-sm" data-testid="team-att-date" />
      </div>
      {err && <p className="text-sm text-red-600">{err}</p>}
      {d && <>
        <div className="flex flex-wrap gap-2 text-sm" data-testid="team-att-summary">
          {[["Staff", d.summary.staff], ["Present", d.summary.present], ["Late", d.summary.late], ["On leave", d.summary.on_leave], ["No sign-in", d.summary.absent]].map(([l, v]) => <span key={l} className="rounded-full border px-3 py-1"><span>{l}</span>{`: ${v}`}</span>)}
        </div>
        <div className="overflow-x-auto rounded-lg border">
          <table className="w-full text-sm" data-testid="team-att-table">
            <thead className="bg-muted/50 text-left text-xs uppercase tracking-wider text-muted-foreground"><tr><th className="p-3">Staff</th><th className="p-3">First sign-in</th><th className="p-3">Last sign-out</th><th className="p-3">Hours</th><th className="p-3">Status</th></tr></thead>
            <tbody>{d.rows.map((r) => (
              <tr key={r.user_id} className="border-t" data-testid={`team-att-row-${r.user_id}`}>
                <td className="p-3"><div translate="no">{r.name}</div>{r.role && <div className="text-xs text-muted-foreground" translate="no">{r.role}</div>}</td>
                <td className="p-3">{r.first_in || "—"}</td>
                <td className="p-3">{r.last_out ? (day === d.today ? `Today · ${r.last_out}` : r.last_out) : "—"}</td>
                <td className="p-3">{r.hours != null ? <span className={r.full_day || day === d.today ? "" : "font-semibold text-amber-700"}>{r.hours.toFixed(2)}</span> : "—"}</td>
                <td className="p-3"><span className={`whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ${BADGE[r.status]}`} data-testid={`team-att-status-${r.user_id}`}>{LABEL[r.status]}</span>
                  {r.on_leave && r.status !== "on_leave" && <span className="ml-1 text-xs text-sky-700">{r.on_leave}</span>}</td>
              </tr>))}</tbody>
          </table>
        </div>
        <p className="text-xs text-muted-foreground">{`Late = first activity after ${d.work_start}. A full day is ${d.required_hours} hours.`} {fmtDate(d.date)}</p>
      </>}
    </div>
  );
}
